import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    let footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animating');
          setTimeout(() => {
            entry.target.classList.add('show-details');
          }, 1000);
          footerObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    if (footerRef.current) {
      footerObserver.observe(footerRef.current);
    }
    
    return () => {
      if (footerRef.current) footerObserver.unobserve(footerRef.current);
    }
  }, []);

  return (
    <footer className="app-footer custom-footer" ref={footerRef}>
      <div className="container footer-details">
        <div className="row w-100 justify-content-between text-start">
          <div className="col-md-3 footer-col">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/">Key Features</Link></li>
              <li><Link to="/">How It Works</Link></li>
              <li><Link to="/">Reviews</Link></li>
            </ul>
          </div>
          <div className="col-md-4 footer-col">
            <h5 className="footer-heading">Contact</h5>
            <ul className="footer-list">
              <li><a href="tel:10001111425">1-000-1111-425</a></li>
              <li><a href="mailto:support@remoteref.com">support@remoteref.com</a></li>
              <li>2978 Esterbn Properk Rd.</li>
            </ul>
          </div>
          <div className="col-md-3 footer-col">
            <h5 className="footer-heading socail-heading">Social Media</h5>
            <div className="footer-socials">
              <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="#"><i className="fa-brands fa-instagram"></i></a>
              <a href="#"><i className="fa-brands fa-twitter"></i></a>
              <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-massive-text" id="text">
        <span>R</span><span>e</span><span>m</span>
        <span className="custom-o-ball"><img src="/images/ball.png" alt="" /></span>
        <span>t</span><span>e</span><span>&nbsp;</span><span>R</span><span>e</span><span>f</span>
      </div>
    </footer>
  );
};

export default Footer;
